/* eslint-disable eag/match-named-export */
import {ThemeRadiusPath} from '../types/ThemePaths';

export const RADIUS_CLASSES: Record<ThemeRadiusPath, string> = {
  // Tailwind standard naming
  xs: 'rounded-[var(--radius-xs)]',
  sm: 'rounded-[var(--radius-sm)]',
  md: 'rounded-[var(--radius-md)]',
  lg: 'rounded-[var(--radius-lg)]',
  xl: 'rounded-[var(--radius-xl)]',
  full: 'rounded-[var(--radius-full)]',
  // Legacy naming (backward compatible)
  xSmall: 'rounded-[var(--radius-xs)]',
  small: 'rounded-[var(--radius-sm)]',
  medium: 'rounded-[var(--radius-md)]',
  large: 'rounded-[var(--radius-lg)]',
  circular: 'rounded-[var(--radius-full)]',
};
